// @flow
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "../../_static/ColorPalette";

export const PrefToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${buildColor("white", "100")};

  @media only screen and (min-width: 768px) {
    border-radius: 4px;
  }
`;

export const TitleDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;

  @media only screen and (min-width: 768px) {
    padding: 20px;
  }
`;

export const ToggleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 12px;
  justify-content: space-between;
  box-shadow: inset 0 -1px 0 ${buildColor("blue", "100")};

  @media only screen and (min-width: 768px) {
    ${({ $isTablet }) =>
      !$isTablet &&
      css`
        box-shadow: none;
      `}
    padding: ${({ isDesktop }) => (isDesktop ? "0 20px 16px" : "20px")};
    justify-content: ${({ $isTablet }) =>
      $isTablet ? "space-between" : "flex-start"};
  }
`;

export const ButtonContainer = styled(Link)`
  display: flex;
  padding: 16px 12px;
  justify-content: space-between;
  box-shadow: inset 0 -1px 0 ${buildColor("blue", "100")};
  background: ${buildColor("white", "100")};
  text-decoration: none;

  @media only screen and (min-width: 768px) {
    ${({ $isTablet }) =>
      !$isTablet &&
      css`
        box-shadow: none;
      `}
    padding: 24px 20px;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;

  [data-qa-label="switch-spinner"] {
    margin-right: 8px;
  }
`;
